<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M11.75 8.5C12.9931 8.5 14 7.49313 14 6.25C14 5.00687 12.9931 4 11.75 4C10.5069 4 9.5 5.00687 9.5 6.25C9.5 7.49313 10.5069 8.5 11.75 8.5Z"
    :stroke="stroke || 'currentColor'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.5 6.25H4" :stroke="stroke || 'currentColor'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16 6.25H14" :stroke="stroke || 'currentColor'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.25 16C9.49313 16 10.5 14.9931 10.5 13.75C10.5 12.5069 9.49313 11.5 8.25 11.5C7.00687 11.5 6 12.5069 6 13.75C6 14.9931 7.00687 16 8.25 16Z"
    :stroke="stroke || 'currentColor'" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M6 13.75H4" :stroke="stroke || 'currentColor'" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M16 13.75H10.375" :stroke="stroke || 'currentColor'" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: 'PreferencesSettingsIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    stroke: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped></style>
